import { useRef, useState } from 'react'
import styles from './Select.module.css'
import { useClickOutside } from '../lib/useClickOutside'
import type { SelectProps } from '../types'

export function Select({ value, onChange, options, className }: SelectProps) {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)
  useClickOutside(ref, open, () => setOpen(false))

  const current = options.find((o) => o.value === value)

  return (
    <div ref={ref} className={`${styles.root} ${className ?? ''}`}>
      <button
        type="button"
        className={styles.trigger}
        onClick={() => setOpen((o) => !o)}
        onKeyDown={(e) => {
          if (e.key === 'Escape') setOpen(false)
        }}
      >
        <span>{current?.label ?? value}</span>
        <span className={styles.chevron}>▾</span>
      </button>
      {open && (
        <ul className={styles.popover} role="listbox">
          {options.map((opt) => (
            <li key={opt.value}>
              <button
                type="button"
                className={`${styles.option} ${opt.value === value ? styles.optionActive : ''}`}
                onClick={() => {
                  onChange(opt.value)
                  setOpen(false)
                }}
              >
                {opt.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
